module.exports = __webpack_public_path__ + "static/media/amount2.5ffbe278.webp";